import { useState, ReactNode } from "react";
import { Flex, Img, Select, Text, useBreakpointValue } from "@chakra-ui/react";

type TableCartProps = {
  children: ReactNode;
};

export function TableCart({ children }: TableCartProps) {
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  return (
    <Flex width="full" direction="column" mb="20px" as="table">
      <Flex
        width="100%"
        borderBottomWidth="1px"
        borderBottomColor="ll-gray.600"
        borderBottomStyle="solid"
        as="thead"
      >
        <Flex as="tr" width="full">
          <Flex
            color={"#58585A"}
            fontSize={"14px"}
            textStyle="Regular"
            flex="4"
            as="td"
            ml={"16px"}
          >
            Produto(s)
          </Flex>

          {isWideVersion && (
            <>
              <Flex color={"#58585A"} fontSize={"14px"} textStyle="Regular" flex="1" as="td"></Flex>
              <Flex
                ml={"10px"}
                color={"#58585A"}
                fontSize={"14px"}
                textStyle="Regular"
                flex="1"
                as="td"
              >
                Quantidade
              </Flex>
              <Flex color={"#58585A"} fontSize={"14px"} textStyle="Regular" flex="1" as="td">
                Valor Unitário
              </Flex>
              <Flex
                color={"#58585A"}
                fontSize={"14px"}
                textStyle="Regular"
                flex="1"
                as="td"
                justifyContent="flex-end"
                mr={"20px"}
              >
                Subtotal
              </Flex>
            </>
          )}
        </Flex>
      </Flex>

      {children}
    </Flex>
  );
}
